<main class="container-geral">
  <section class="cabecalho">
    <div class="d-flex justify-content-center">
      <h1 class="titulo fonte-DM-Sans">
        {{ "COMPONENTS.EQUIPAMENTOS.title" | transloco }}
      </h1>
    </div>

    <div class="d-flex gap-3">      
      <button *ngIf="permissoes.criar" class="btn-cadastrar-listagem fonte-DM-Sans" routerLink="cadastro">
        {{ "COMPONENTS.EQUIPAMENTOS.createButton" | transloco }}
      </button>
    </div>
  </section>

  <section>
    <div class="d-flex flex-row-reverse gap-4 mb-2 mt-3">
      <div class="container-filtro">
        <object
          class="icone-lupa"
          data="assets/icones-filtros/icone-lupa.svg"
          type="image/svg+xml"
        ></object>
        <input
          id="filtro-frota"
          class="filtro-pesquisa color-input"
          (keyup)="filtrarEquipamentos($event)"
          [placeholder]="
            'COMPONENTS.EQUIPAMENTOS.searchPlaceholder' | transloco
          "
        />
      </div>

      <app-filtro-clientes
        (carregarCliente)="buscarEquipamentos($event)"
      ></app-filtro-clientes>

      <div class="container-filtro">
        <object
          class="icone-caminhao"
          data="assets/icone-caminhao.svg"
          type="image/svg+xml"
        ></object>
        <select
          id="filtro-tipo"
          class="crud-select form-select"
          (change)="filtrarEquipamentos($event)"
        >
          <option value="null">
            {{ "COMPONENTS.EQUIPAMENTOS.allTypes" | transloco }}
          </option>
          <option *ngFor="let item of tiposEquipamento" [value]="item.dado">
            {{ "COMPONENTS.EQUIPAMENTOS.types." + item.dado | transloco }}
          </option>
        </select>
      </div>
    </div>

    <div [class]="!loading ? 'scrollTable' : ''">
      <table mat-table [dataSource]="dataSource" class="mat-elevation-none">
        <tr *matNoDataRow>
          <td
            [attr.colspan]="displayedColumns.length"
            class="equipamento-vazio text-center text-muted"
            [hidden]="loading"
          >
            {{ "COMPONENTS.EQUIPAMENTOS.empty" | transloco }}
          </td>
        </tr>

        <ng-container matColumnDef="vc_frota">
          <th mat-header-cell *matHeaderCellDef>
            {{ "COMPONENTS.EQUIPAMENTOS.columns.fleet" | transloco }}
          </th>
          <td mat-cell *matCellDef="let e" [hidden]="loading">
            {{ e.vc_frota }}
          </td>
        </ng-container>

        <ng-container matColumnDef="en_tipo">
          <th mat-header-cell *matHeaderCellDef>
            {{ "COMPONENTS.EQUIPAMENTOS.columns.type" | transloco }}
          </th>
          <td mat-cell *matCellDef="let e" [hidden]="loading">
            <span
              class="etiqueta tipoEquipamento"
              [style]="
                '--cor-tipo-equipamento:' + getCorTipoEquipamento(e.en_tipo)
              "
            >
              {{ "COMPONENTS.EQUIPAMENTOS.types." + e.en_tipo | transloco }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="identificador_comunicador">
          <th mat-header-cell *matHeaderCellDef>
            {{ "COMPONENTS.EQUIPAMENTOS.columns.communicator" | transloco }}
          </th>
          <td mat-cell *matCellDef="let e">
            <ng-container *ngIf="e.agview_connect?.vc_imei">
              {{ e.agview_connect.vc_imei }}
            </ng-container>
            <ng-container *ngIf="e.agview_700?.vc_codigo_hardware">
              {{ e.agview_700.vc_codigo_hardware }}
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="tipo_comunicador">
          <th mat-header-cell *matHeaderCellDef>
            {{ "COMPONENTS.EQUIPAMENTOS.columns.communicatorType" | transloco }}
          </th>
          <td mat-cell *matCellDef="let e">
            <ng-container *ngIf="e.agview_connect?.vc_imei">
              <span class="etiqueta" style="--cor-tipo-equipamento: #2e86de">
                {{
                  "COMPONENTS.EQUIPAMENTOS.form.communicator.agviewConnect"
                    | transloco
                }}
              </span>
            </ng-container>
            <ng-container *ngIf="e.agview_700?.vc_codigo_hardware">
              <span class="etiqueta" style="--cor-tipo-equipamento: #10ac84">
                {{
                  "COMPONENTS.EQUIPAMENTOS.form.communicator.agview700"
                    | transloco
                }}
              </span>
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>
            {{ "COMPONENTS.EQUIPAMENTOS.columns.status" | transloco }}
          </th>
          <td mat-cell *matCellDef="let e" [hidden]="loading">
            <span
              class="etiqueta"
              [ngClass]="e.bl_ativo ? 'etiqueta-ativa' : 'etiqueta-desativada'"
            >
              {{
                e.bl_ativo
                  ? ("COMPONENTS.EQUIPAMENTOS.active" | transloco)
                  : ("COMPONENTS.EQUIPAMENTOS.inactive" | transloco)
              }}
            </span>
          </td>
        </ng-container>

        <ng-container *ngIf="permissoes.exibirAcoes" matColumnDef="acoes">
          <th mat-header-cell *matHeaderCellDef class="col-acoes">
            {{ "COMPONENTS.EQUIPAMENTOS.columns.actions" | transloco }}
          </th>
          <td mat-cell *matCellDef="let e" [hidden]="loading">
            <div class="td-botoes d-flex justify-content-center">
              @if (permissoes.editar) {
                <button
                  class="botaoAcao"
                  [matTooltip]="
                    'COMPONENTS.EQUIPAMENTOS.tooltips.chat' | transloco
                  "
                >
                  <img src="assets/equipamentos/coa.svg" />
                </button>

                <button
                  class="botaoAcao"
                  [routerLink]="'editar/' + e.sr_id"
                  [matTooltip]="
                    'COMPONENTS.EQUIPAMENTOS.tooltips.edit' | transloco
                  "
                >
                  <img src="assets/compartilhados/caneta.svg" />
                </button>
              }

              <button
                *ngIf="permissoes.excluir"
                class="botaoAcao"
                (click)="excluir(e.sr_id)"
                [matTooltip]="
                  'COMPONENTS.EQUIPAMENTOS.tooltips.delete' | transloco
                "
              >
                <img src="assets/compartilhados/lixeira.svg" />
              </button>
            </div>
          </td>
        </ng-container>
        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>

    <app-loading *ngIf="loading" [linhas]="5" [colunas]="1" tipo="listagem" />
    <mat-paginator #paginator style="display: none"></mat-paginator>

    <nav class="pagination-controller" *ngIf="listaPaginas.length">
      <ul class="pagination">
        <li class="page-item">
          <button class="page-link transparent" (click)="voltarPagina()">
            <img src="assets/compartilhados/setaLeft.svg" />
          </button>
        </li>

        <li *ngFor="let p of listaPaginas" class="page-item">
          <button
            class="page-link"
            [class.active]="p === paginator.pageIndex + 1"
            (click)="mudarPagina(p - 1)"
          >
            {{ p }}
          </button>
        </li>
        <li class="page-item">
          <button class="page-link transparent" (click)="proximaPagina()">
            <img src="assets/compartilhados/setaRight.svg" />
          </button>
        </li>
      </ul>
    </nav>
  </section>
</main>
